module.exports = __webpack_public_path__ + "img/home_badminton.679cfc4a.jpg";